window.app.controller('finHealthCtrl', ['$scope', '$mdDialog', '$http', function ($scope, $mdDialog, $http) {
    $scope.emailChecks = {};
    $scope.FHData = {};
    $scope.closedFinHealthNumber = 0;
    $scope.userMailAgentLink = "";
    $scope.dublicate = false;
    $scope.rejected = false;
    $scope.userIsRegistrated = false;

    $scope.user = {
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        pesel: "",
        socialNumber: "",
        bankAccount: "",
        livPostcode: "",
        livCity: "",
        livStreet: "",
        livBuilding: "",
        livApartment: "",
        livRegion: "",
        occupation: "",
        empType: "",
        accept_terms: "",
        accept_fh_personal_data_terms: "",
        accept_raport_mailing_policy: ""
    };

    $scope.formUserData = () => {
        $scope.userData = Object.assign({}, $scope.user);
        $scope.userData.accept_terms = $scope.userData.accept_terms ? "1" : "0";
        $scope.userData.accept_fh_personal_data_terms = $scope.userData.accept_fh_personal_data_terms ? "1" : "0";
        $scope.userData.accept_raport_mailing_policy = $scope.userData.accept_raport_mailing_policy ? "1" : "0";
        delete $scope.userData.occupation;
        delete $scope.userData.empType;
        return $scope.userData
    }

    // $('.openTariffs').click (function () {
    //     $('.fh-tariffs-section').slideDown({ duration: 500 });
    //     $scope.scrollTo(".fh-tariffs-section")
    // });
    $('.openSlider1').click(function () {
        $scope.scrollTo(".fh-slider_1")
    });
    $('.openApp').click(function () {
        $('.blockHidden').slideDown({ duration: 500 });
        $scope.scrollTo("#singleApp")
    });

    $scope.showFHInform = () => {
        $mdDialog.show({
            clickOutsideToClose: true,
            preserveScope: true,
            template: $scope.FHInform,
            parent: angular.element(document.body),
            scope: $scope,
        });
        $scope.$watch('$viewContentLoaded', function () {
            let mdDialog = $("#modal-popup").parent();
            mdDialog.css({ "max-width": "1000px" });
        })
    }

    $scope.sendFinHealth = () => {
        $scope.sendXHR({
            url: '/api/front/application/fin-health/send',
            data: {
                email: $scope.user.email,
                occupation: $scope.user.occupation,
                empType: $scope.user.empType
            },
            successFunc: $scope.manageFHResp
        });
    }

    $scope.saveApplication = function () {
        $scope.emailChecks[$scope.user.email].data.emailConfirmed === 0 ? $scope.resendRegConfirmLetter() : "";
        $scope.FHData = $scope.formUserData();
        $scope.sendXHR({
            url: '/api/front/application/save-application/save',
            data: $scope.FHData,
            successFunc: $scope.sendFinHealth
        });
    };

    $scope.manageFHResp = (resp) => {
        $scope.userIsRegistrated = $scope.emailChecks[$scope.user.email].data.userExists;
        ga('send', 'event', 'Application_FinHealth', 'click');
        if (resp.data.approve) {
            let link = resp.data.url
            var ekassaWin = window.open(link);
            if (!ekassaWin) {
                //POPUP BLOCKED
                window.location.href = link;
            }
            $scope.userMailAgentLink = `http://${$scope.user.email.split('@')[1]}`;
            $scope.showSuccessPopUp($scope.userMailAgentLink)
        } else if (resp.data.error === "Invalid data") {
            $scope.insertErrorText("Prawdopodobnie w danych zawartych we wniosku występują błędy. Sprawdź swoje dane, wprowadź zmiany i ponownie wyślij wniosek.")
        } else if (resp.data.error === "Duplicate client" || resp.data.error === "Reject") {
            $scope.rejected = true;
        } else if (resp.data.error === "Duplicate request") {
            $scope.dublicate = true;
        }
    }

    $scope.insertErrorText = (str) => {
        $(".error-space").text(str)
    }

    $scope.resendRegConfirmLetter = () => {
        return $http({
            method: 'POST',
            url: '/api/front/registration/registration/resend-letter',
            data: {
                type: 'user',
                email: $scope.user.email
            }
        });
    };

    $scope.showSuccessPopUp = (userMailAgentLink) => {
        $mdDialog.show({
            preserveScope: true,
            template:
                `<div id="modal-popup">
                      <div class="layout" layout-align="end">
                      <span class="modal-close-btn" ng-click="finishProcess()" aria-label="close">X</span>
                      </div>
                      <p class="title text-center">
                        Dziękujemy za wniosek.
                        <span ng-if="!${$scope.userIsRegistrated}">
                            <br><br>
                            Przejdź na pocztę <a target="_blank" href=${userMailAgentLink} class="mail-agent-link">${$scope.user.email}</a> i potwierdź rejestrację na stronie Racoongo.com
                        </span>
                      </p>
                  </div>`,
            parent: angular.element(document.body),
            scope: $scope,
        });
    }

    $scope.finishProcess = () => {
        $scope.closeDialog();
        window.location.reload();
    }

    $(document).ready(function () {
        $(".regulamin ~ .check-text").click(function () {
            $scope.setClick(".regulamin");
            ($("#regulamin").prop("checked")) ? $scope.user.accept_terms = true : $scope.user.accept_terms = false;
        });
        $(".agreement-policy ~ .check-text").click(function () {
            $scope.setClick(".agreement-policy");
            ($("#agreement-policy").prop("checked")) ? $scope.user.accept_fh_personal_data_terms = true : $scope.user.accept_fh_personal_data_terms = false;
        });
        $(".agreement-data ~ .check-text").click(function () {
            $scope.setClick(".agreement-data");
            ($("#agreement-data").prop("checked")) ? $scope.user.accept_raport_mailing_policy = true : $scope.user.accept_raport_mailing_policy = false;
        });
    })

    $scope.FHInform = `<div id="modal-popup">
                            <div class="layout" layout-align="end">
                                <span class="modal-close-btn" ng-click="closeDialog()" aria-label="close">X</span>
                            </div>
                            <div class="fhinfo">
                                <p>
                                1. W celu przyjęcia decyzji o otrzymaniu pożyczki, każda firma – wierzyciel:
                                    <ul>
                                        <li>Ocenia ile pożyczek wziąłeś do tej pory, i czy spłacałeś je na czas.</li>
                                        <li>A czym większa ilość pożyczek spłaconych na czas, tym więcej pożyczkodawców będzie gotowa udzielić Tobie pożyczki.</li>
                                    </ul><br>
                                    Zwróć uwagę, iż ważną rolę dla przyjęcia pozytywnej decyzji kredytowej, mają pożyczki które
                                    zostały spłacone niedawno oraz na czas. Nawet jeżeli kiedyś w historii kredytowej pojawiły się
                                    fakty, co do nieterminowej spłaty, a następnie sytuacja się zmieniła i zacząłeś spłacać
                                    zaległości kredytowe na czas - dla kredytodawców oznacza to, że dokonałeś korekty i są
                                    podstawy by udzielić Ci pożyczki.<br><br>
                                    Tym samym im więcej pożyczek spłacono zgodnie z harmonogramem w ostatnim czasie, tym
                                    większe jest prawdopodobieństwo uzyskania pożyczki.<br><br>
                                    Nasi klienci już aktywnie korzystają z usługi &quot;Poprawa historii kredytowej&quot;. Są tacy, którzy
                                    otrzymali pożyczkę zaraz po skorzystaniu z naszej usługi. Jeśli nie otrzymałeś pożyczki zaraz po
                                    skorzystaniu z usługi, aby poprawić historię, skorzystaj z usługi ponownie:
                                    <ul>
                                        <li>Korzystasz z usługi raz = odnotujesz jeden fakt pozytywnej historii kredytowej.</li>
                                        <li>Pokaż w swojej historii więcej pożyczek, spłacanych terminowo.</li>
                                        <li>Im bardziej pozytywna historia kredytowa, tym lepsze warunki kredytowania.</li>
                                    </ul> <br>
                                    2. Na podstawie zebranych danych, najlepszy efekt uzyskasz korzystając z produktu przez
                                    okres od 3 do 12 miesięcy.<br><br>
                                    Prowizja od kolejnych produktów jest stopniowo obniżana, aż do kwoty 40 zł. Dlatego też
                                    wybierz taryfę, która najbardziej Ci odpowiada i zobacz, jak zmienia się wobec Ciebie zaufanie
                                    pożyczkodawców. To nigdy nie było łatwiejsz.
                                </p>
                            </div>
                        </div>`

}])



// WEBPACK FOOTER //
// src/js/controllers/finHealth/finHealthCtrl.js